import { render, staticRenderFns } from "./CustomerMotorStart.vue?vue&type=template&id=65fa0594"
import script from "./CustomerMotorStart.vue?vue&type=script&lang=js"
export * from "./CustomerMotorStart.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/customer-motor.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports